"use client";

// Límite de error de toda la app. Sin esto, cualquier excepción de render deja
// la pantalla en blanco con el texto de Next en inglés y el usuario cierra la
// app creyendo que se rompió del todo.
//
// El detalle técnico NO se muestra: al técnico paraguayo no le dice nada y
// puede filtrar rutas o datos internos. Va a la consola (y al `digest` que
// queda del lado del servidor) para que lo veamos nosotros.
import Link from "next/link";
import { useEffect } from "react";
import Icon from "../components/Icon";

export default function ErrorGeneral({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Error en la app:", error);
  }, [error]);

  return (
    <main className="min-h-screen bg-[#14191B] text-[#EDF1EF] flex items-center justify-center p-6">
      <div className="w-full max-w-sm flex flex-col gap-6 text-center">
        <div>
          <p className="font-mono text-xs tracking-[0.2em] text-[#E8A23C] uppercase">busco</p>
          <Icon name="alert" size={38} className="mx-auto text-[#E8A23C] mt-4" />
        </div>

        <div>
          <h1 className="text-xl font-bold tracking-tight">Algo se rompió de nuestro lado</h1>
          <p className="text-sm text-[#B5C0BB] mt-2">
            No es culpa tuya y no perdiste nada de lo que ya habías guardado.
            Probá de nuevo; si sigue igual, esperá unos minutos.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <button
            onClick={() => reset()}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#E8A23C] text-[#201404] font-bold py-3 hover:brightness-105"
          >
            <Icon name="zap" size={18} strokeWidth={2.25} /> Probar de nuevo
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/5 font-semibold py-3 hover:bg-white/10"
          >
            <Icon name="home" size={18} /> Ir a la portada
          </Link>
        </div>

        {/* El digest es un código opaco que genera el servidor: no revela nada
            y es lo único con lo que soporte puede encontrar el error exacto */}
        {error.digest && (
          <p className="font-mono text-[11px] text-[#808D88]">
            Código de referencia: {error.digest}
          </p>
        )}
      </div>
    </main>
  );
}
